// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RnrAssetManager from "../../assets/RnrAssetManager.bs.js";
import * as RnrCommonComponents from "../RnrCommonComponents.bs.js";

var ise = RnrAssetManager.getImage("ise.svg");

function RnrISE(Props) {
  var content = Props.content;
  return React.createElement("div", {
              className: "u-text-centre"
            }, React.createElement("img", {
                  src: ise
                }), React.createElement("p", undefined, content.status.ise), RnrCommonComponents.getRetryComponent(content));
}

var make = RnrISE;

export {
  ise ,
  make ,
  
}
/* ise Not a pure module */
